module.exports = __webpack_public_path__ + "static/media/detalle-gris.8ca7d925.svg";